import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "./Footer";

const PrivacyPolicy = () => {
  return (
   <>
  <div className="terms-service">
    <Container>
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <div className="terms-content mt-4 mb-5 p-4">
            <h1 className="text-center mb-4">🔐 Privacyverklaring</h1>
            <p className="version-info text-center mb-4">
              Laatst bijgewerkt: 27 maart 2025
            </p>

            <p>Bij Klypadrelm nemen we jouw privacy serieus. Deze verklaring legt uit hoe we informatie verzamelen, gebruiken en beschermen wanneer je onze website bezoekt.</p>
            <p>👉 Let op: Klypadrelm is een gratis sociaal casinoplatform.</p>
            <p>We bieden geen kansspelen aan, geen aankopen, en er is geen mogelijkheid om echt geld of prijzen te winnen.</p>

            <h2>🧾 1. Welke informatie verzamelen wij?</h2>
            <p>We verzamelen alleen anonieme gebruiksgegevens om de gebruikerservaring te verbeteren. Dit kan het volgende omvatten:</p>
            <ul>
              <li>🌐 Browsertype en apparaat</li>
              <li>🕒 Tijdstip en duur van het bezoek</li>
              <li>📄 Welke pagina’s zijn bezocht</li>
              <li>📍 Geschatte locatie (gebaseerd op IP-adres)</li>
            </ul>
            <p>We verzamelen geen persoonlijk identificeerbare informatie zoals naam, adres of betalingsgegevens.</p>
            <p>We verwerken ook geen financiële gegevens, omdat de dienst geen echt geld bevat.</p>

            <h2>🍪 2. Gebruik van cookies</h2>
            <p>Wij gebruiken cookies om:</p>
            <ul>
              <li>Te begrijpen hoe bezoekers de website gebruiken</li>
              <li>De functionaliteit en gebruikerservaring te verbeteren</li>
              <li>Verkeer en prestaties te meten</li>
            </ul>
            <p>Je kunt cookies beheren of verwijderen via je browserinstellingen.</p>

            <h2>🧠 3. Hoe gebruiken we data?</h2>
            <p>De gegevens worden alleen gebruikt voor:</p>
            <ul>
              <li>📊 Statistiek en analyse (bijv. Google Analytics)</li>
              <li>🔧 Technische verbetering van de website</li>
              <li>🛡️ Bescherming tegen misbruik en beveiligingsinbreuken</li>
            </ul>
            <p>We verkopen of delen geen gegevens met derden, tenzij dit nodig is voor technische werking (bijv. serverhosting).</p>

            <h2>🎰 4. Geen kansspelen</h2>
            <p>Klypadrelm is geen online casino met echt geld. Onze spellen zijn:</p>
            <ul>
              <li>🆓 Volledig gratis te spelen</li>
              <li>💸 Zonder mogelijkheid tot stortingen of aankopen</li>
              <li>❌ Bieden geen prijzen in echt geld of fysieke beloningen</li>
            </ul>
            <p>De dienst is uitsluitend bedoeld voor entertainment en sociaal plezier.</p>

            <h2>🧑‍⚖️ 5. Jouw rechten</h2>
            <p>Volgens de Algemene Verordening Gegevensbescherming (AVG) heb je recht op:</p>
            <ul>
              <li>📝 Inzage in welke gegevens we hebben</li>
              <li>✏️ Correctie van onjuiste informatie</li>
              <li>❌ Verzoek tot verwijdering van jouw gegevens ("recht om vergeten te worden")</li>
              <li>🛑 Beperking of bezwaar tegen bepaald datagebruik</li>
            </ul>
            <p>Om deze rechten uit te oefenen, neem contact met ons op via meister@gmail.com.</p>

            <h2>🧷 6. Gegevensbeveiliging</h2>
            <p>We gebruiken moderne beveiligingsmaatregelen om informatie te beschermen tegen ongeautoriseerde toegang, wijziging of verlies.</p>

            <h2>🌍 7. Opslag en verwerking binnen de EER</h2>
            <p>Alle gegevensverwerking gebeurt volgens de AVG en gegevens worden opgeslagen binnen de Europese Economische Ruimte (EER).</p>

            <h2>📬 8. Contact</h2>
            <p>Heb je vragen over deze privacyverklaring of jouw gegevens?</p>
            <p>Klypadrelm AS</p>
            <p>📧 E-mail: meister@gmail.com</p>
            <p>📍 Dronning Eufemias gate 16, 0191 Oslo, Noorwegen</p>
            <p>📞 Telefoon: +47 22 83 70 10</p>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
  <Footer />
</>

  );
};

export default PrivacyPolicy;
